import { Card, Col, Form, FormControl, Row } from "react-bootstrap";
import { showErrorInput } from "../../../../utils/helperFunctions";
import { Controller } from "react-hook-form";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { CustomSelect } from "assets/kits/inputs/Input.tsx";
import WebInfoContext from "../../../../context/WebInfo/WebInfoContext.ts";

import UploadFile from "assets/kits/UploadFile/index.tsx";
import { isEmpty } from "lodash";

export const translateCategory = (category) => {
  if (!category) return category;

  return {
    value: category?.hashtag?.id,
    label: category?.hashtag?.txt,
    optionList: category?.hashtag?.options,
    subs: category?.subs?.map((sub) => translateSubCategory(sub)),
  };
};

export const translateSubCategory = (sub) => {
  return {
    value: sub.id,
    label: sub.txt,
    hashtag_status: sub.hashtag_status,
    optionList: sub.options,
  };
};

const FirstDetails = ({
  formControl,
  files,
  setFiles,
  article,
  brandOptions,
}) => {
  const { categorys } = useContext(WebInfoContext);

  const categoryOptions = useMemo(() => {
    return categorys.map((category) => translateCategory(category));
  }, [categorys]);
  return (
    <div className="w-100">
      <Col xs={12} className="pd-x-6 mr-t-16">
        <span className="lgn-bold">عنوان {article ? "مقاله" : "محصول"}: </span>
        <Form.Control
          {...formControl.register("title")}
          className="shadow-none he-40 mr-t-8 rd-8 pd-x-12 font-14-500"
          placeholder="عنوان را وارد نمایید"
          isInvalid={formControl.formState.errors.title}
        />

        {showErrorInput(formControl.formState.errors, "title")}
      </Col>

      <div className="d-flex flex-wrap" style={{ zIndex: 100 }}>
        <Col xs={12} md={6} className="mr-t-16 pd-x-6 ">
          <Controller
            name="category"
            control={formControl.control}
            render={({ field }) => (
              <>
                <CustomSelect
                  {...field}
                  containerClassName="shadow-none bg border-0 sm-medium rd-8 pd-x-0 lgn-bold"
                  className="mr-t-8 lgn-medium"
                  placeholder="انتخاب کنید"
                  title="دسته بندی:"
                  options={categoryOptions}
                  labelClassName="p-0 m-0"
                  inputHeight={40}
                />
                {showErrorInput(formControl.formState.errors, "category")}
              </>
            )}
          />
        </Col>

        <Col xs={12} md={6} className="mr-t-16 pd-x-6 ">
          <Controller
            name="subCategorys"
            control={formControl.control}
            render={({ field }) => (
              <>
                <CustomSelect
                  {...field}
                  containerClassName="shadow-none bg border-0 sm-medium rd-8 pd-x-0 lgn-bold"
                  className="mr-t-8 lgn-medium"
                  placeholder="انتخاب کنید"
                  // isDisabled={(isEmpty(categorySelect))}
                  isDisabled={isEmpty(formControl.getValues("category"))}
                  title="زیر دسته:"
                  isMulti={true}
                  labelClassName="p-0 m-0"
                  // options={!isEmpty(categorySelect) ? categorySelect.subs : []}
                  options={
                    !isEmpty(formControl.getValues("category"))
                      ? formControl.getValues("category").subs
                      : []
                  }
                  inputHeight={40}
                />
                {showErrorInput(formControl.formState.errors, "subCategorys")}
              </>
            )}
          />
        </Col>
        <Col xs={12} md={6} className="mr-t-16 pd-x-6 ">
          <Controller
            name="brand"
            control={formControl.control}
            render={({ field }) => (
              <>
                <CustomSelect
                  {...field}
                  containerClassName="shadow-none bg border-0 sm-medium rd-8 pd-x-0 lgn-bold"
                  className="mr-t-8 lgn-medium"
                  placeholder="انتخاب کنید"
                  // isDisabled={(isEmpty(categorySelect))}
                  title="برند:"
                  isMulti={false}
                  labelClassName="p-0 m-0"
                  // options={!isEmpty(categorySelect) ? categorySelect.subs : []}
                  options={brandOptions}
                  inputHeight={40}
                />
              </>
            )}
          />
        </Col>
      </div>

      <Col xs={12} className="pd-x-6 mr-t-16">
        <Controller
          name="description"
          control={formControl.control}
          render={({ field }) => (
            <>
              <span className="lgn-bold color-bk-04">
                توضیحات:{" "}
                <span className="font-14-500">
                  ({`${field.value ? field.value.length : 0}/300`})
                </span>
              </span>

              <Form.Control
                as="textarea"
                {...field}
                onChange={(e) => {
                  if (e.target.value.length > 300) return;
                  field.onChange(e);
                }}
                className="input-custom shadow-none he-100 mr-t-8 rd-8 pd-y-8 pd-x-12 font-14-500"
                placeholder="توضیحات را وارد نمایید"
                isInvalid={formControl.formState.errors.description}
              />
              {showErrorInput(formControl.formState.errors, "description")}
            </>
          )}
        />
      </Col>

      <div
        className={`d-flex flex-wrap  w-100 ${
          article
            ? ""
            : "pd-x-16 justify-content-md-around justify-content-center"
        }`}
      >
        <Col xs={12} sm={3} md={2} className="card pd-x-6 mr-x-6 mr-t-16">
          <Card.Header className="bg-white">
            <span className="lgn-bold mr-b-8 text-nowrap">
              کاور {article ? "مقاله" : "محصول"}:
            </span>
          </Card.Header>
          <Card.Body className="d-flex justify-content-center">
            <UploadFile
              // value={getFiles("cover")}
              // value={(parentFiles && parentFiles?.cover) && parentFiles?.cover}
              name="cover"
              file={files}
              setFile={setFiles}
              typeFile="image"
            />
          </Card.Body>
        </Col>

        {article ? (
          ""
        ) : (
          <Col xs={12} sm className="card pd-x-6 mr-x-6 mr-t-16">
            <Card.Header className="bg-white">
              <span className="lgn-bold mr-b-8">فایل های جانبی:</span>
            </Card.Header>
            <Card.Body className="pd-b-0">
              <UploadFile
                name="file"
                file={files}
                setFile={setFiles}
                mode="multi"
                typeFile="multi"
              />
            </Card.Body>
          </Col>
        )}
      </div>
    </div>
  );
};

export default FirstDetails;
